import { Typography } from '@mui/material';

import * as Styled from '../../UserPermissions.styles';

import { SectionHeaderProps } from './SectionHeader.types';

export const SectionHeader = ({ title, renderPermissionRow }: SectionHeaderProps) => {
  return (
    <Styled.SectionHeader>
      <Typography variant="h6">{title}</Typography>

      {renderPermissionRow && renderPermissionRow()}
    </Styled.SectionHeader>
  );
};
